import React, { useEffect, useRef, useState } from 'react';

const StatsBar = () => {
  const stats = [
    { value: 10, label: "Fully Owned Systems" },
    { value: 205, label: "Active Brands", suffix: "+" },
    { value: 110000, label: "Product Lines", suffix: "+" },
    { value: 50, label: "Team Members", suffix: "+" },
    { value: 3, label: "International Offices" },
  ];

  const [counts, setCounts] = useState(stats.map(() => 0));
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          
          stats.forEach((stat, index) => {
            const startTime = Date.now();
            const duration = 2000;
            const startValue = 0;
            const endValue = stat.value;
            
            const updateCount = () => {
              const currentTime = Date.now();
              const elapsed = currentTime - startTime;
              const progress = Math.min(elapsed / duration, 1);
              
              // Easing function for smooth animation
              const easeOutQuart = 1 - Math.pow(1 - progress, 4);
              const currentValue = Math.floor(startValue + (endValue - startValue) * easeOutQuart);
              
              setCounts(prev => {
                const newCounts = [...prev];
                newCounts[index] = currentValue;
                return newCounts;
              });
              
              if (progress < 1) {
                requestAnimationFrame(updateCount);
              } else {
                // Ensure final value is exact
                setCounts(prev => {
                  const newCounts = [...prev];
                  newCounts[index] = endValue;
                  return newCounts;
                });
              }
            };
            
            // Stagger the animations
            setTimeout(updateCount, index * 200);
          });
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [hasAnimated, stats]);

  return (
    <section className="stats-bar" ref={sectionRef} id='Aboutus'>
      <div className="stats-container">
        {stats.map((item, index) => (
          <div className="stat-item" key={index}>
            <h2>
              {item.value >= 1000 ? 
                counts[index].toLocaleString() : 
                counts[index]
              }
              {item.suffix || ""}
            </h2>
            <p>{item.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsBar;